import { useEffect, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import { api } from '../api/client';
import { readFirstTouch } from '../analytics/attribution';

const TOLD_KEY = 'cs_signup_source_told';

const told = () => {
  try {
    return window.localStorage.getItem(TOLD_KEY) === '1';
  } catch {
    return false;
  }
};

/**
 * Tells the API, once, where a new account came from: the first page this
 * browser landed on, with its campaign and ad click (analytics/attribution.js
 * remembers it on the first load). Ads went live on 2026-09-28 and nothing
 * could say which sign-ups they had brought: PostHog and the ads tag only see
 * people who accept cookies. What the API keeps is on the account, not in
 * analytics (services/signup_source.py). A browser whose owner declined has
 * nothing to tell: the first touch is deleted the moment they say no.
 */
export default function SignupSource() {
  const { isAuthenticated } = useAuth();
  const asked = useRef(false);

  useEffect(() => {
    if (!isAuthenticated || asked.current || told()) return;
    const touch = readFirstTouch();
    if (!touch?.url) return;
    asked.current = true;
    api.keepSignupSource({ url: touch.url, referrer: touch.referrer || null, at: touch.at })
      .then(() => {
        // Kept or refused (an older account, or already known): asking again changes nothing
        try { window.localStorage.setItem(TOLD_KEY, '1'); } catch { /* it is asked again next load, and refused */ }
      })
      .catch(() => {
        // The network, or the API mid-deploy: ask on the next load
        asked.current = false;
      });
  }, [isAuthenticated]);

  return null;
}
